<template>
  <div>
    <!-- Filtros de Búsqueda -->
    <v-card ref="filterCard" class="pa-4 mb-4 filter-card elevation-0">
      <v-row dense align="center">
        <v-col cols="12" lg="9" class="d-flex align-center">
          <div class="d-flex flex-wrap align-center gap-3 w-100">
            <div class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-domain</v-icon>
              <span class="pill-label">Unidad:</span>
              <span class="pill-value text-truncate" style="max-width: 150px;" :title="nombreUnidadNegocioSeleccionada">
                {{ nombreUnidadNegocioSeleccionada || 'No seleccionada' }}
              </span>
            </div>
            <div class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-office-building-marker</v-icon>
              <span class="pill-label">Sede:</span>
              <span class="pill-value text-truncate" style="max-width: 150px;" :title="nombreSedeSeleccionada">
                {{ nombreSedeSeleccionada || 'No seleccionada' }}
              </span>
            </div>
            <div class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-calendar-range</v-icon>
              <span class="pill-label">Rango:</span>
              <span class="pill-value">{{ fechaInicio || '-' }} - {{ fechaFin || '-' }}</span>
            </div>
            <div v-if="docenteBusqueda" class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-account-search</v-icon>
              <span class="pill-label">Docente:</span>
              <span class="pill-value text-truncate" style="max-width: 150px;" :title="docenteBusqueda">
                {{ docenteBusqueda }}
              </span>
            </div>
            <div class="filter-pill">
              <v-icon small class="mr-1 primary--text">mdi-cash-multiple</v-icon>
              <span class="pill-label">Estado:</span>
              <span class="pill-value">{{ etiquetaEstadoPago }}</span>
            </div>
            <div class="filter-pill" title="Módulos">
              <v-icon small class="mr-1 primary--text">mdi-counter</v-icon>
              <span class="pill-value">{{ cantidadModulo }}</span>
            </div>
          </div>
        </v-col>

        <v-col cols="12" lg="3" class="d-flex justify-lg-end justify-start flex-wrap gap-2 mt-2 mt-lg-0">
          <v-btn
            depressed
            outlined
            color="primary"
            class="rounded-lg action-btn"
            :title="columnasExpandidas ? 'Contraer columnas' : 'Expandir columnas'"
            @click="columnasExpandidas = !columnasExpandidas"
          >
            <v-icon color="primary">{{ columnasExpandidas ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
          </v-btn>

          <v-btn
            depressed
            outlined
            color="primary"
            class="rounded-lg action-btn"
            title="Filtros"
            @click="abrirDialogoFiltros"
          >
            <v-icon color="primary">mdi-filter-variant</v-icon>
          </v-btn>

          <v-btn
            depressed
            outlined
            color="success"
            class="rounded-lg action-btn"
            title="Exportar Excel"
            :loading="descargandoExcel"
            :disabled="!sedeId"
            @click="exportarExcel"
          >
            <v-icon color="success">mdi-file-excel-outline</v-icon>
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="rounded-lg action-btn"
            title="Recargar"
            :loading="cargando"
            :disabled="!sedeId"
            @click="listarRestableciendoPagina"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Dialog de Filtros -->
    <v-dialog v-model="mostrarDialogoFiltros" max-width="600" overlay-color="#0f172a" overlay-opacity="0.6" content-class="custom-dialog">
      <v-card class="rounded-xl overflow-hidden filter-dialog-card">
        <v-card-title class="dialog-header px-6 py-5 d-flex align-center justify-space-between border-bottom">
          <div class="d-flex align-center">
            <div class="filter-header-icon mr-3">
              <v-icon color="primary">mdi-filter-variant</v-icon>
            </div>
            <div>
              <div class="text-h6 font-weight-bold slate-900--text" style="line-height: 1.2;">Configurar Filtros</div>
              <div class="text-caption grey--text text--darken-1 mt-0.5">Establezca los criterios para filtrar los pagos de docentes</div>
            </div>
          </div>
          <v-btn icon color="grey darken-1" @click="mostrarDialogoFiltros = false" small class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 py-4 dialog-body">
          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" class="mb-2 pr-sm-2">
              <span class="input-label">Unidad de negocio</span>
              <v-autocomplete
                v-model="unidadNegocioIdDialogo"
                :items="unidadesNegocio"
                item-text="nombre"
                item-value="id"
                placeholder="Seleccione unidad..."
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-domain"
                :loading="cargandoUnidadesNegocio"
                @change="alCambiarUnidadNegocioDialogo"
                class="rounded-lg custom-input mt-1" />
            </v-col>

            <v-col cols="12" sm="6" class="mb-2 pl-sm-2">
              <span class="input-label">Sede</span>
              <v-autocomplete
                v-model="sedeIdDialogo"
                :items="sedesFiltradasDialogo"
                item-text="nombre"
                item-value="id"
                placeholder="Seleccione sede..."
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-office-building-marker"
                :disabled="!unidadNegocioIdDialogo"
                :loading="cargandoSedes"
                class="rounded-lg custom-input mt-1" />
            </v-col>
          </v-row>

          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" class="mb-2 pr-sm-2">
              <span class="input-label">Fecha de inicio</span>
              <v-menu
                ref="menuFechaInicioDialogo"
                v-model="menuFechaInicioDialogo"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaInicioDialogo"
                    placeholder="Seleccione fecha..."
                    readonly
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    class="rounded-lg custom-input mt-1" />
                </template>
                <v-date-picker
                  v-model="fechaInicioDialogo"
                  locale="es-ES"
                  @input="menuFechaInicioDialogo = false" />
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" class="mb-2 pl-sm-2">
              <span class="input-label">Fecha de fin</span>
              <v-menu
                ref="menuFechaFinDialogo"
                v-model="menuFechaFinDialogo"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaFinDialogo"
                    placeholder="Seleccione fecha..."
                    readonly
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    class="rounded-lg custom-input mt-1" />
                </template>
                <v-date-picker
                  v-model="fechaFinDialogo"
                  locale="es-ES"
                  @input="menuFechaFinDialogo = false" />
              </v-menu>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" class="mb-2">
              <span class="input-label">Estado de pago</span>
              <v-btn-toggle
                v-model="estadoPagoDialogo"
                color="primary"
                mandatory
                dense
                borderless
                class="mt-1 estado-pago-toggle">
                <v-btn value="todos" small outlined>
                  <v-icon left small>mdi-format-list-bulleted</v-icon>
                  Todos
                </v-btn>
                <v-btn value="pendiente_pago" small outlined>
                  <v-icon left small>mdi-cash-minus</v-icon>
                  Pendiente Pago
                </v-btn>
                <v-btn value="pendiente_pago_sin_requisito" small outlined>
                  <v-icon left small>mdi-cash-remove</v-icon>
                  Pendiente (Sin Requisito)
                </v-btn>
                <v-btn value="pagado" small outlined>
                  <v-icon left small>mdi-cash-check</v-icon>
                  Pagado
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="12">
              <span class="input-label">Buscar docente</span>
              <v-text-field
                v-model="docenteBusquedaDialogo"
                placeholder="Ingrese CI o nombre completo del docente..."
                outlined
                dense
                clearable
                hide-details
                prepend-inner-icon="mdi-account-search"
                class="rounded-lg custom-input mt-1" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-6 py-4 bg-light d-flex justify-end gap-2">
          <v-btn
            depressed
            outlined
            class="rounded-lg action-btn cancel-btn"
            @click="mostrarDialogoFiltros = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="rounded-lg action-btn apply-btn px-6"
            :disabled="!sedeIdDialogo || !fechaInicioDialogo || !fechaFinDialogo"
            @click="aplicarFiltrosDialogo"
          >
            <v-icon left small>mdi-check</v-icon>
            Aplicar Filtros
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Información de Requisitos -->
    <v-dialog v-model="mostrarDialogoRequisitos" max-width="560" overlay-color="#0f172a" overlay-opacity="0.6" content-class="custom-dialog">
      <v-card class="rounded-xl overflow-hidden filter-dialog-card">
        <v-card-title class="dialog-header px-6 py-5 d-flex align-center justify-space-between border-bottom">
          <div class="d-flex align-center">
            <div class="filter-header-icon mr-3">
              <v-icon color="primary">mdi-information-outline</v-icon>
            </div>
            <div>
              <div class="text-h6 font-weight-bold slate-900--text" style="line-height: 1.2;">Requisitos del Módulo</div>
              <div class="text-caption grey--text text--darken-1 mt-0.5">Significado de cada requisito evaluado</div>
            </div>
          </div>
          <v-btn icon color="grey darken-1" @click="mostrarDialogoRequisitos = false" small class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 py-4 dialog-body">
          <div class="requisito-leyenda">
            <span class="req-badge req-success">Portal</span>
            <span class="requisito-leyenda-texto">= Cumple el requisito</span>
          </div>
          <div class="requisito-leyenda mb-3">
            <span class="req-badge req-error">Portal</span>
            <span class="requisito-leyenda-texto">= No cumple el requisito</span>
          </div>

          <div v-for="req in INFO_REQUISITOS" :key="req.clave" class="requisito-info-item">
            <div class="requisito-info-titulo">{{ req.etiqueta }}</div>
            <div class="requisito-info-descripcion">{{ req.descripcion }}</div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-6 py-4 bg-light d-flex justify-end">
          <v-btn depressed color="primary" class="rounded-lg action-btn px-6" @click="mostrarDialogoRequisitos = false">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Barra de Progreso -->
    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-4 rounded" height="4" />

    <!-- Contenedor Inferior: tabla + paginación, la paginación siempre visible completa -->
    <div
      ref="contenidoInferior"
      class="contenido-inferior"
      :style="alturaContenidoPx ? { height: alturaContenidoPx + 'px' } : {}">
    <!-- Contenedor del Detalle -->
    <div class="detalle-pago-docente-container">
      <!-- Estado Vacío -->
      <div v-if="!cargando && items.length === 0" class="empty-state-card py-12 px-6 text-center">
        <v-icon size="64" color="grey lighten-1" class="mb-3">mdi-database-alert-outline</v-icon>
        <h3 class="text-h6 font-weight-medium grey--text text--darken-3 mb-1">Sin información para mostrar</h3>
        <p class="body-2 grey--text text--darken-1 max-w-md mx-auto mb-0">
          {{ sedeId ? 'No se encontró información de pagos de docentes para los filtros seleccionados.' : 'Seleccione una Unidad de Negocio y una Sede para buscar la información.' }}
        </p>
      </div>

      <!-- Tabla Principal -->
      <v-simple-table v-else dense fixed-header class="tabla-control-detallado-sede">
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 60px" class="text-center">#</th>
              <th style="min-width: 130px">Sede</th>
              <th v-if="columnasExpandidas" style="min-width: 250px">Programa</th>
              <th>Módulos</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fila, indice) in items" :key="indice">
              <td class="text-center index-column">{{ (pagina - 1) * itemsPorPagina + indice + 1 }}</td>
              <td>
                <div class="program-sede">
                  <v-icon x-small color="grey darken-1">mdi-map-marker-outline</v-icon>
                  {{ fila.sede }}
                </div>
              </td>
              <td v-if="columnasExpandidas">
                <div class="d-flex align-center flex-wrap mb-2">
                  <span class="program-code-badge mr-2">{{ fila.programa?.codigo || fila.programa?.idesam }}</span>
                  <span :class="['custom-badge', getEstadoClass(fila.programa?.estado)]">{{ fila.programa?.estado }}</span>
                </div>
                <div class="program-name">{{ fila.programa?.nombre }}</div>
              </td>
              <td>
                <!-- Tabla de Módulos Anidada -->
                <v-simple-table dense class="tabla-modulos-anidada">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Módulo</th>
                        <th v-if="columnasExpandidas">Fechas</th>
                        <th>Docente</th>
                        <th>
                          <div class="d-flex align-center">
                            Requisitos
                            <v-btn icon x-small class="ml-1" title="¿Qué significa cada requisito?" @click="mostrarDialogoRequisitos = true">
                              <v-icon x-small color="grey darken-1">mdi-information-outline</v-icon>
                            </v-btn>
                          </div>
                        </th>
                        <th class="text-center">Habilitado Pago / Pagado</th>
                        <th>Planilla</th>
                        <th>Importes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="modulo in fila.modulos" :key="modulo.numero">
                        <td>
                          <div class="font-weight-medium" style="color: #1e293b;">{{ modulo.numero }} - {{ modulo.nombre }}</div>
                          <span :class="['custom-badge', 'badge-xs', 'mt-1', getEstadoClass(modulo.estado)]">{{ modulo.estado }}</span>
                        </td>
                        <td v-if="columnasExpandidas">
                          <div class="date-container">
                            <div class="date-item">
                              <span class="date-label">Ini:</span>
                              <span class="date-val">{{ modulo.fechaInicio || '-' }}</span>
                            </div>
                            <div class="date-item">
                              <span class="date-label">Fin:</span>
                              <span class="date-val">{{ modulo.fechaFin || '-' }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div v-if="modulo.docentes" class="docente-info">
                            <div class="docente-name">{{ modulo.docentes.nombreCompleto }}</div>
                            <div class="docente-ci">
                              <v-icon x-small class="mr-1 grey--text">mdi-card-account-details-outline</v-icon>
                              {{ modulo.docentes.ci || '-' }}
                            </div>
                          </div>
                          <span v-else class="docente-unassigned">
                            <v-icon x-small class="mr-1">mdi-account-alert-outline</v-icon>
                            Sin asignar
                          </span>
                        </td>
                        <td>
                          <div class="d-flex flex-wrap">
                            <span
                              v-for="req in requisitosModulo(modulo.cumple_requisitos)"
                              :key="req.clave"
                              :class="['req-badge', req.cumple ? 'req-success' : 'req-error']">
                              {{ req.etiqueta }}
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <div class="d-flex flex-column align-center" style="gap: 4px;">
                            <span :class="['status-pill', modulo.habilitado_pago ? 'status-yes' : 'status-no']">
                              <v-icon x-small :color="modulo.habilitado_pago ? 'green darken-3' : 'red darken-3'">
                                {{ modulo.habilitado_pago ? 'mdi-check' : 'mdi-close' }}
                              </v-icon>
                              Habilitado: {{ modulo.habilitado_pago ? 'Sí' : 'No' }}
                            </span>
                            <span :class="['status-pill', modulo.pagado ? 'status-yes' : 'status-no']">
                              <v-icon x-small :color="modulo.pagado ? 'green darken-3' : 'red darken-3'">
                                {{ modulo.pagado ? 'mdi-check' : 'mdi-close' }}
                              </v-icon>
                              Pagado: {{ modulo.pagado ? 'Sí' : 'No' }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div v-if="modulo.planilla" class="planilla-info">
                            <div class="planilla-codigo">{{ modulo.planilla.codigo || '-' }}</div>
                            <div class="planilla-fecha">
                              <v-icon x-small class="mr-1 grey--text">mdi-calendar-month-outline</v-icon>
                              {{ modulo.planilla.fecha || '-' }}
                            </div>
                            <span :class="['custom-badge', 'badge-xs', 'mt-1', getEstadoClassPlanilla(modulo.planilla.estado)]">
                              {{ etiquetaEstadoPlanilla(modulo.planilla.estado) }}
                            </span>
                          </div>
                          <span v-else class="docente-unassigned">
                            <v-icon x-small class="mr-1">mdi-file-document-outline</v-icon>
                            Sin planilla
                          </span>
                        </td>
                        <td>
                          <div class="importes-container">
                            <span v-if="!tieneImportes(modulo.importes)" class="docente-unassigned">
                              <v-icon x-small class="mr-1">mdi-currency-usd-off</v-icon>
                              Sin importes
                            </span>
                            <template v-else>
                              <div class="importe-item">
                                <span class="importe-label">Importe:</span>
                                <span class="importe-val">{{ formatearMoneda(modulo.importes?.importe) }}</span>
                              </div>
                              <div class="importe-item" v-if="columnasExpandidas">
                                <span class="importe-label">Desc. ESAM:</span>
                                <span class="importe-val">{{ formatearMoneda(modulo.importes?.descuento_esam) }}</span>
                              </div>
                              <div class="importe-item" v-if="columnasExpandidas">
                                <span class="importe-label">Subtotal:</span>
                                <span class="importe-val">{{ formatearMoneda(modulo.importes?.sub_total) }}</span>
                              </div>
                              <div class="importe-item" v-if="columnasExpandidas">
                                <span class="importe-label">Ret. RC-IVA:</span>
                                <span class="importe-val">{{ formatearMoneda(modulo.importes?.retencion_rc_iva) }}</span>
                              </div>
                              <div class="importe-item" v-if="columnasExpandidas">
                                <span class="importe-label">Ret. IT:</span>
                                <span class="importe-val">{{ formatearMoneda(modulo.importes?.retencion_it) }}</span>
                              </div>
                              <div class="importe-item importe-liquido" v-if="columnasExpandidas">
                                <span class="importe-label">Líquido pagable:</span>
                                <span class="importe-val">{{ formatearMoneda(modulo.importes?.liquido_pagable) }}</span>
                              </div>
                            </template>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <!-- Paginación -->
    <div class="d-flex align-center justify-space-between flex-wrap mt-4 px-1 gap-2" v-if="items.length > 0">
      <div class="d-flex align-center">
        <span class="caption grey--text text--darken-1 font-weight-medium mr-4">
          Página {{ pagina }} de {{ metadatos?.totalPaginas || 1 }}
        </span>
        <v-select
          :items="[10, 25, 50, 75, 100]"
          label="Items por página"
          v-model="itemsPorPagina"
          outlined
          dense
          hide-details
          style="max-width: 150px"
          @change="listarRestableciendoPagina"
          class="rounded-lg custom-input" />
      </div>

      <v-pagination
        v-model="pagina"
        :length="metadatos?.totalPaginas || 0"
        :total-visible="7"
        @input="listar"
        color="primary"
        class="custom-pagination" />
    </div>
    </div>
  </div>
</template>

<script>
import ReporteDocenteService from '../services/reporte-docente.service';

const ETIQUETAS_REQUISITOS = {
  portal: 'Portal',
  rrhh: 'RRHH',
  firma: 'Firma',
  revisado_academico: 'Rev. Académico',
  carta: 'Carta',
  relacion_portal_rrhh: 'Relación Portal-RRHH',
};

const INFO_REQUISITOS = [
  { clave: 'portal', etiqueta: 'Portal', descripcion: 'Indica si el docente registró y/o cargó la información correspondiente al módulo en el Portal.' },
  { clave: 'rrhh', etiqueta: 'RRHH', descripcion: 'Indica si el área de Recursos Humanos habilitó o validó al docente para el pago del módulo.' },
  { clave: 'firma', etiqueta: 'Firma', descripcion: 'Indica si se cuenta con la firma del docente en la documentación requerida del módulo.' },
  { clave: 'revisado_academico', etiqueta: 'Rev. Académico', descripcion: 'Indica si el área Académica revisó y aprobó la información del módulo.' },
  { clave: 'carta', etiqueta: 'Carta', descripcion: 'Indica si se cuenta con la carta o documento de conformidad correspondiente al módulo.' },
  { clave: 'relacion_portal_rrhh', etiqueta: 'Relación Portal-RRHH', descripcion: 'Indica si la información cargada en el Portal coincide con los datos registrados en RRHH.' },
];

const COLORES_ESTADO = {
  Concluido: 'success',
  'En desarrollo': 'orange',
  'No iniciado': 'grey',
};

const ETIQUETAS_ESTADO_PLANILLA = {
  GENERADO: 'Generado',
  PENDIENTE_GERENTE: 'Pendiente Gerente',
  PENDIENTE_DAF: 'Pendiente DAF',
  APROBADO: 'Aprobado',
  OBSERVADO: 'Observado',
  RECHAZADO: 'Rechazado',
};

const CLASES_ESTADO_PLANILLA = {
  GENERADO: 'state-default',
  PENDIENTE_GERENTE: 'state-en-desarrollo',
  PENDIENTE_DAF: 'state-en-desarrollo',
  APROBADO: 'state-concluido',
  OBSERVADO: 'state-en-desarrollo',
  RECHAZADO: 'state-no-iniciado',
};

const ETIQUETAS_ESTADO_PAGO = {
  todos: 'Todos',
  pendiente_pago: 'Pendiente Pago',
  pendiente_pago_sin_requisito: 'Pendiente Pago (Sin Requisito)',
  pagado: 'Pagado',
};

export default {
  name: 'ControlDetalladoPagoDocentePorSedeTab',
  data() {
    return {
      cargando: false,
      descargandoExcel: false,
      cargandoUnidadesNegocio: false,
      unidadesNegocio: [],
      unidadNegocioId: null,
      cargandoSedes: false,
      sedes: [],
      sedeId: null,
      fechaInicio: null,
      fechaFin: null,
      fechaInicioDialogo: null,
      fechaFinDialogo: null,
      menuFechaInicioDialogo: false,
      menuFechaFinDialogo: false,
      pendientePago: true,
      pendientePagoSinRequisito: false,
      pagado: false,
      pagina: 1,
      itemsPorPagina: 10,
      metadatos: null,
      cantidadModulo: 0,
      items: [],
      mostrarDialogoFiltros: false,
      unidadNegocioIdDialogo: null,
      sedeIdDialogo: null,
      docenteBusqueda: null,
      docenteBusquedaDialogo: null,
      estadoPagoDialogo: 'pendiente_pago',
      columnasExpandidas: false,
      alturaContenidoPx: null,
      mostrarDialogoRequisitos: false,
      INFO_REQUISITOS,
    };
  },
  computed: {
    sedesFiltradas() {
      if (!this.unidadNegocioId) {
        return [];
      }

      return this.sedes.filter((sede) => sede.unidad_negocio == this.unidadNegocioId);
    },
    sedesFiltradasDialogo() {
      if (!this.unidadNegocioIdDialogo) {
        return [];
      }

      return this.sedes.filter((sede) => sede.unidad_negocio == this.unidadNegocioIdDialogo);
    },
    nombreUnidadNegocioSeleccionada() {
      return this.unidadesNegocio.find((unidad) => unidad.id == this.unidadNegocioId)?.nombre || '';
    },
    nombreSedeSeleccionada() {
      return this.sedes.find((sede) => sede.id == this.sedeId)?.nombre || '';
    },
    estadoPagoActual() {
      if (this.pendientePago) return 'pendiente_pago';
      if (this.pendientePagoSinRequisito) return 'pendiente_pago_sin_requisito';
      if (this.pagado) return 'pagado';
      return 'todos';
    },
    etiquetaEstadoPago() {
      return ETIQUETAS_ESTADO_PAGO[this.estadoPagoActual];
    },
  },
  async created() {
    const anioActual = new Date().getFullYear();
    this.fechaInicio = `${anioActual}-01-01`;
    this.fechaFin = `${anioActual}-12-31`;

    await this.obtenerUnidadSede();

    this.unidadNegocioId = this.unidadesNegocio[0]?.id ?? null;
    this.sedeId = this.sedesFiltradas[0]?.id ?? null;

    if (this.sedeId) {
      this.listarRestableciendoPagina();
    }
  },
  mounted() {
    this.actualizarAlturaTabla();
    window.addEventListener('resize', this.actualizarAlturaTabla);
    if (window.ResizeObserver && this.$refs.filterCard) {
      this.observadorFilterCard = new ResizeObserver(() => this.actualizarAlturaTabla());
      this.observadorFilterCard.observe(this.$refs.filterCard.$el || this.$refs.filterCard);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.actualizarAlturaTabla);
    if (this.observadorFilterCard) {
      this.observadorFilterCard.disconnect();
    }
  },
  watch: {
    items() {
      this.actualizarAlturaTabla();
    },
    cargando() {
      this.actualizarAlturaTabla();
    },
  },
  methods: {
    actualizarAlturaTabla() {
      this.$nextTick(() => {
        const contenedor = this.$refs.contenidoInferior;
        if (!contenedor) return;

        // Se mide la posición real del contenedor (ya refleja el alto del encabezado
        // de filtros y de la barra de progreso, sin necesidad de sumarlos a mano).
        const top = contenedor.getBoundingClientRect().top;
        const margenInferiorPagina = 24;
        const disponible = window.innerHeight - top - margenInferiorPagina;
        this.alturaContenidoPx = Math.max(disponible, 280);
      });
    },
    abrirDialogoFiltros() {
      this.unidadNegocioIdDialogo = this.unidadNegocioId;
      this.sedeIdDialogo = this.sedeId;
      this.fechaInicioDialogo = this.fechaInicio;
      this.fechaFinDialogo = this.fechaFin;
      this.docenteBusquedaDialogo = this.docenteBusqueda;
      this.estadoPagoDialogo = this.estadoPagoActual;
      this.mostrarDialogoFiltros = true;
    },
    alCambiarUnidadNegocioDialogo() {
      this.sedeIdDialogo = null;
    },
    aplicarFiltrosDialogo() {
      if (this.fechaInicioDialogo > this.fechaFinDialogo) {
        this.$notify({
          group: 'notifications',
          title: 'Error de Validación',
          text: 'La Fecha de inicio no puede ser mayor a la Fecha de fin',
          type: 'warning',
        });
        return;
      }
      this.unidadNegocioId = this.unidadNegocioIdDialogo;
      this.sedeId = this.sedeIdDialogo;
      this.fechaInicio = this.fechaInicioDialogo;
      this.fechaFin = this.fechaFinDialogo;
      this.docenteBusqueda = this.docenteBusquedaDialogo?.trim() || null;
      this.pendientePago = this.estadoPagoDialogo === 'pendiente_pago' ? true : null;
      this.pendientePagoSinRequisito = this.estadoPagoDialogo === 'pendiente_pago_sin_requisito';
      this.pagado = this.estadoPagoDialogo === 'pagado';
      this.mostrarDialogoFiltros = false;
      this.listarRestableciendoPagina();
    },
    async obtenerUnidadSede() {
      this.cargandoUnidadesNegocio = true;
      this.cargandoSedes = true;

      try {
        const { data } = await ReporteDocenteService.getUnidadSede();
        const filas = data || [];

        this.unidadesNegocio = filas.map((fila) => fila.empresa);
        this.sedes = filas.flatMap((fila) =>
          fila.sedes.map((sede) => ({ ...sede, unidad_negocio: fila.empresa.id })),
        );
      } catch (error) {
        this.unidadesNegocio = [];
        this.sedes = [];
      } finally {
        this.cargandoUnidadesNegocio = false;
        this.cargandoSedes = false;
      }
    },
    etiquetaEstadoPlanilla(estado) {
      return ETIQUETAS_ESTADO_PLANILLA[estado] || estado || '-';
    },
    getEstadoClassPlanilla(estado) {
      return CLASES_ESTADO_PLANILLA[estado] || 'state-default';
    },
    formatearMoneda(valor) {
      const numero = Number(valor ?? 0);
      return numero.toLocaleString('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    tieneImportes(importes) {
      if (!importes) return false;

      return [
        importes.importe,
        importes.descuento_esam,
        importes.sub_total,
        importes.retencion_rc_iva,
        importes.retencion_it,
        importes.liquido_pagable,
      ].some((valor) => Number(valor ?? 0) !== 0);
    },
    colorEstado(estado) {
      return COLORES_ESTADO[estado] || 'grey';
    },
    getEstadoClass(estado) {
      if (!estado) return 'state-default';
      const normalized = estado.toLowerCase().trim();
      if (normalized === 'concluido' || normalized === 'concluído') return 'state-concluido';
      if (normalized === 'en desarrollo') return 'state-en-desarrollo';
      if (normalized === 'no iniciado') return 'state-no-iniciado';
      return 'state-default';
    },
    requisitosModulo(cumpleRequisitos) {
      if (!cumpleRequisitos) {
        return [];
      }

      return Object.keys(ETIQUETAS_REQUISITOS).map((clave) => ({
        clave,
        etiqueta: ETIQUETAS_REQUISITOS[clave],
        cumple: Boolean(cumpleRequisitos[clave]),
      }));
    },
    listarRestableciendoPagina() {
      if (!this.sedeId) {
        return;
      }

      this.pagina = 1;
      this.listar();
    },
    async listar() {
      if (!this.sedeId) {
        return;
      }

      this.cargando = true;

      try {
        const { data } = await ReporteDocenteService.controlDetalladoPagoDocentePorSede({
          sede_id: this.sedeId,
          pagina: this.pagina,
          itemsPorPagina: this.itemsPorPagina,
          fecha_inicio: this.fechaInicio || undefined,
          fecha_fin: this.fechaFin || undefined,
          pendiente_pago: this.pendientePago || undefined,
          pendiente_pago_sin_requisito: this.pendientePagoSinRequisito || undefined,
          pagado: this.pagado || undefined,
          docente_busqueda: this.docenteBusqueda || undefined,
        });

        this.items = data?.data || [];
        this.metadatos = data?.paginacion || null;
        this.cantidadModulo = data?.cantidadModulo ?? 0;
      } catch (error) {
        this.items = [];
        this.metadatos = null;
        this.cantidadModulo = 0;
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: error?.response?.data?.mensaje || 'No se pudo obtener el control detallado de pago docente por sede',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    async exportarExcel() {
      if (!this.sedeId) {
        return;
      }

      this.descargandoExcel = true;

      try {
        const response = await ReporteDocenteService.controlDetalladoPagoDocentePorSedeExcel({
          sede_id: this.sedeId,
          sede_nombre: this.nombreSedeSeleccionada || undefined,
          fecha_inicio: this.fechaInicio || undefined,
          fecha_fin: this.fechaFin || undefined,
          pendiente_pago: this.pendientePago || undefined,
          pendiente_pago_sin_requisito: this.pendientePagoSinRequisito || undefined,
          pagado: this.pagado || undefined,
          docente_busqueda: this.docenteBusqueda || undefined,
        });

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const enlace = document.createElement('a');

        enlace.href = url;
        enlace.download = this.obtenerNombreArchivoExcel(response) || 'control-detallado-pago-docente-por-sede.xlsx';
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
        URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Descarga Exitosa',
          text: 'El archivo Excel se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'No se pudo descargar el archivo Excel.',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
    obtenerNombreArchivoExcel(response) {
      const contentDisposition = response.headers['content-disposition'];

      if (!contentDisposition) {
        return null;
      }

      const coincidencia = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

      return coincidencia && coincidencia[1] ? coincidencia[1].replace(/['"]/g, '') : null;
    },
  },
};
</script>

<style scoped>
.contenido-inferior {
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

.detalle-pago-docente-container {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

.tabla-control-detallado-sede ::v-deep > .v-data-table__wrapper > table > tbody > tr > td {
  vertical-align: top;
  padding-top: 14px;
  padding-bottom: 14px;
}

.tabla-control-detallado-sede ::v-deep table {
  border-collapse: collapse;
  width: 100%;
}

.tabla-control-detallado-sede ::v-deep thead th {
  background-color: #f8fafc !important;
  color: #1e293b !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  border-bottom: 2px solid #e2e8f0 !important;
  height: 48px !important;
}

.tabla-control-detallado-sede ::v-deep tbody tr {
  transition: background-color 0.2s ease;
}

.tabla-control-detallado-sede ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
}

.tabla-control-detallado-sede ::v-deep tbody td {
  border-bottom: 1px solid #e2e8f0 !important;
  color: #334155;
  font-size: 0.875rem;
}

.tabla-modulos-anidada {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  margin: 4px 0 8px 0;
  overflow: hidden;
  background: #ffffff;
}

.tabla-modulos-anidada ::v-deep thead th {
  background-color: #f1f5f9 !important;
  color: #475569 !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
  height: 36px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.tabla-modulos-anidada ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
}

.tabla-modulos-anidada ::v-deep tbody td {
  height: 40px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  font-size: 0.8rem;
  color: #475569;
  vertical-align: middle;
}

/* Filter Card Styling */
.filter-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05) !important;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.filter-pill {
  display: inline-flex;
  align-items: center;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 0.8rem;
  color: #334155;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.filter-pill:hover {
  border-color: #cbd5e1;
  background-color: #f1f5f9;
  transform: translateY(-1px);
}

.pill-label {
  font-weight: 600;
  color: #64748b;
  margin-right: 6px;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.03em;
}

.pill-value {
  font-weight: 600;
  color: #1e293b;
}

.action-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  height: 40px !important;
  border-radius: 8px !important;
}

/* Dialog Styles */
.custom-dialog {
  border-radius: 16px !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  overflow: hidden !important;
}

.filter-dialog-card {
  background: #ffffff !important;
  border-radius: 16px !important;
}

.dialog-header {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.filter-header-icon {
  background: #eff6ff;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbeafe;
}

.dialog-body {
  background: #ffffff !important;
}

.dialog-section-header {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f1f5f9;
}

.input-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  display: inline-block;
  margin-bottom: 6px;
}

.custom-input ::v-deep .v-input__slot {
  background-color: #f8fafc !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none !important;
  min-height: 40px !important;
}

.custom-input ::v-deep .v-input__slot:hover {
  background-color: #f1f5f9 !important;
  border-color: #94a3b8 !important;
}

.custom-input ::v-deep .v-input__slot:focus-within {
  background-color: #ffffff !important;
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) !important;
}

.custom-input.v-input--is-disabled ::v-deep .v-input__slot {
  background-color: #f1f5f9 !important;
  border-color: #e2e8f0 !important;
  cursor: not-allowed;
}

.custom-input.v-input--is-disabled ::v-deep input {
  color: #94a3b8 !important;
}

.custom-input ::v-deep fieldset {
  border: none !important;
}

.custom-input ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.custom-input ::v-deep .v-input__append-inner {
  margin-top: 8px !important;
}

.custom-input ::v-deep .v-icon {
  color: #64748b !important;
  font-size: 20px !important;
}

.custom-input ::v-deep .v-select__selection {
  color: #1e293b !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

.custom-input ::v-deep input {
  color: #1e293b !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

.bg-light {
  background-color: #f8fafc;
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.rounded-md {
  border-radius: 6px !important;
}

/* Toggle buttons styling */
.estado-pago-toggle {
  background-color: transparent !important;
  width: 100%;
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .estado-pago-toggle {
    grid-template-columns: 1fr;
  }
}

.estado-pago-toggle .v-btn {
  height: 40px !important;
  border: 1px solid #cbd5e1 !important;
  background-color: #ffffff !important;
  color: #475569 !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  font-size: 0.8rem !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
  justify-content: flex-start;
  padding-left: 12px !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.estado-pago-toggle .v-btn::before {
  display: none;
}

.estado-pago-toggle .v-btn--active {
  background-color: #eff6ff !important;
  border-color: #2563eb !important;
  color: #1d4ed8 !important;
  font-weight: 600 !important;
}

.estado-pago-toggle .v-btn--active .v-icon {
  color: #2563eb !important;
}

.cancel-btn {
  border: 1px solid #cbd5e1 !important;
  color: #475569 !important;
  background-color: #ffffff !important;
}

.cancel-btn:hover {
  background-color: #f8fafc !important;
  color: #1e293b !important;
}

.apply-btn {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2), 0 2px 4px -1px rgba(37, 99, 235, 0.1) !important;
  transition: all 0.2s ease !important;
}

.apply-btn:hover {
  box-shadow: 0 6px 8px -1px rgba(37, 99, 235, 0.25), 0 3px 6px -1px rgba(37, 99, 235, 0.15) !important;
  transform: translateY(-1px);
}

.apply-btn:active {
  transform: translateY(0);
}

.apply-btn.v-btn--disabled {
  background: #e2e8f0 !important;
  color: #94a3b8 !important;
  box-shadow: none !important;
  border-color: #e2e8f0 !important;
}

.close-btn {
  transition: transform 0.2s ease;
}

.close-btn:hover {
  transform: rotate(90deg);
}

/* Badges & Pills */
.custom-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 9999px;
  line-height: 1.25;
  white-space: nowrap;
}

.badge-xs {
  font-size: 0.65rem;
  padding: 1px 6px;
}

.state-concluido {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid rgba(46, 125, 50, 0.2);
}

.state-en-desarrollo {
  background-color: #fff3e0;
  color: #ef6c00;
  border: 1px solid rgba(239, 108, 0, 0.2);
}

.state-no-iniciado {
  background-color: #f5f5f5;
  color: #616161;
  border: 1px solid rgba(97, 97, 97, 0.2);
}

.state-default {
  background-color: #eceff1;
  color: #455a64;
  border: 1px solid rgba(69, 90, 100, 0.2);
}

.program-code-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 4px;
  background-color: #e3f2fd;
  color: #1565c0;
  border: 1px solid rgba(21, 101, 192, 0.2);
  line-height: 1.25;
}

.program-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-top: 4px;
}

.program-sede {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.index-column {
  color: #94a3b8;
  font-weight: 500;
  font-size: 0.85rem;
}

/* Requirements & Status Pills */
.req-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  font-size: 0.65rem;
  font-weight: 500;
  border-radius: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  white-space: nowrap;
}

.req-success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid rgba(46, 125, 50, 0.15);
}

.req-error {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid rgba(198, 40, 40, 0.15);
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 9999px;
  white-space: nowrap;
}

.status-yes {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid rgba(46, 125, 50, 0.2);
}

.status-no {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid rgba(198, 40, 40, 0.2);
}

/* Dates & Docente */
.date-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.date-item {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
}

.date-label {
  color: #64748b;
  font-weight: 500;
  width: 26px;
  display: inline-block;
}

.date-val {
  color: #334155;
  font-weight: 500;
}

.docente-info {
  display: flex;
  flex-direction: column;
}

.docente-name {
  font-weight: 500;
  color: #334155;
}

.docente-ci {
  font-size: 0.75rem;
  color: #64748b;
  display: flex;
  align-items: center;
}

.planilla-info {
  display: flex;
  flex-direction: column;
}

.planilla-codigo {
  font-weight: 500;
  color: #334155;
}

.planilla-fecha {
  font-size: 0.75rem;
  color: #64748b;
  display: flex;
  align-items: center;
}

.importes-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 140px;
}

.importe-item {
  font-size: 0.75rem;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.importe-label {
  color: #64748b;
  font-weight: 500;
}

.importe-val {
  color: #334155;
  font-weight: 500;
}

.importe-liquido .importe-label,
.importe-liquido .importe-val {
  color: #1565c0;
  font-weight: 700;
}

.docente-unassigned {
  font-size: 0.75rem;
  color: #94a3b8;
  font-style: italic;
  display: inline-flex;
  align-items: center;
  background-color: #f8fafc;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px dashed #cbd5e1;
}

/* Pagination Custom Styles */
.custom-pagination {
  margin-top: 0 !important;
}

.custom-pagination ::v-deep .v-pagination__item {
  box-shadow: none !important;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.85rem;
  min-width: 32px;
  height: 32px;
}

.custom-pagination ::v-deep .v-pagination__item--active {
  background-color: #1565c0 !important;
  color: white !important;
  border-color: #1565c0 !important;
}

.custom-pagination ::v-deep .v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  width: 32px;
  height: 32px;
}

/* Empty State Card */
.empty-state-card {
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  max-width: 600px;
  margin: 2rem auto;
}

.max-w-md {
  max-width: 28rem;
}

/* Dialog de Requisitos */
.requisito-leyenda {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.requisito-leyenda-texto {
  font-size: 0.8rem;
  color: #475569;
  font-weight: 500;
}

.requisito-info-item {
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}

.requisito-info-item:last-child {
  border-bottom: none;
}

.requisito-info-titulo {
  font-weight: 700;
  color: #1e293b;
  font-size: 0.85rem;
  margin-bottom: 2px;
}

.requisito-info-descripcion {
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.4;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>
